import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'components';
import styled from 'styled-components';

const ModalAlert = ({show, title, children, onHide}) => {
  const [visible, setVisible] = useState(false);

  const handleClose = () => {
    onHide();
    setVisible(false);
  }

  const handleShow = () => setVisible(true);

  useEffect(() => {
    if(show) handleShow();
  }, [show])

  return (
    <ModalContainer show={visible} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{children}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button  primary="true" onClick={handleClose}>OK</Button>
      </Modal.Footer>
    </ModalContainer>
  );
};

const ModalContainer = styled(Modal)`
  font-size: ${({ theme }) => theme.sizes.normal};
  color: ${({ theme }) => theme.palette.grayscale[1]};

  .modal-header {
    padding-top: 0;
  }

  .modal-content {
    border-radius: 0.5rem;
    padding: 1rem 0 ;
    border: 0;
  }

  .modal-footer {
    padding: 0.2rem;
  }
`;

export default ModalAlert;
